import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const ToastCloseButton = () => {
  return <FontAwesomeIcon icon={faTimesCircle} style={{ fontSize: "1.5rem" }} />;
};

export default ToastCloseButton;
